import styled from 'styled-components';

/**
 * This layout makes sure that the iframe doesn't grow beyond provided width/height,
 * is centered horizontally, and when shrunk, the aspect ratio is preserved.
 */
const OuterContainer = styled.div<{ $width: string }>`
  max-width: 100%;
  width: ${(props) => props.$width}px;
  margin: 24px auto;
`;

const InnerContainer = styled.div<{ $width: string; $height: string }>`
  height: 0;
  padding-top: ${(props) => (100 * parseFloat(props.$height)) / parseFloat(props.$width)}%;
  position: relative;
`;

const StyledIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Iframe = (props: { src: string; width: string; height: string }) => {
  if (!props.width || !props.height) {
    return (
      <p>
        <em>Error: iframe|... requires width and height parameters.</em>
      </p>
    );
  }
  return (
    <OuterContainer $width={props.width}>
      <InnerContainer $width={props.width} $height={props.height}>
        <StyledIframe {...props} />
      </InnerContainer>
    </OuterContainer>
  );
};

export default Iframe;
